import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import SideMenu from "./components/sideMenu/SideMenu";
import { loadState } from "./utils/loadState";

export const PrivateRoutes = () => {
    const user = useSelector((state) => state.persistedReducer.userInfo);
    return <div>{user && user.token && user.token.split(" ")[1] ? <Outlet /> : <Outlet />}</div>;
};
